import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { JobAnalysisPluginService } from './job-analysis-plugin.service';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import * as _ from 'lodash';

@Component({
    selector: 'jobanalysis-edit',
    templateUrl: './job-analysis-edit.component.html',
    standalone: false
})
export class JobAnalysisEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  public plugin: any;
  public processing = false;
  public editForm: UntypedFormGroup;
  public jobAnalysisItems: any;
  public modelCurrentItem: any;
  public modelsValues: any = [];
  private jobToRemove: number;

  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('modelsModal', { static: true })
  modelsModal: ModalComponent;
  @ViewChild('jobDeleteConfirm', { static: true })
  jobDeleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private service: JobAnalysisPluginService,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.jobAnalysisItems = this.plugin.config.JobAnalysisItems;
      if (this.plugin.inspection.data && this.plugin.inspection.data.machine) {
        //this.modelsValues = _.map(this.plugin.inspection.data.machine, 'name').sort();
        this.modelsValues = this.plugin.inspection.data.machine;
        _.each(this.modelsValues, (el) => {
          el.label = el.name;
        });
      }
      this.modelsValues = _.sortBy(this.modelsValues, ['label']);
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  initJobAnalysisItem(el?: any) {
    return this.fb.group({
      JobData: this.initJobData(el ? el.JobData : null),
      Setup: this.initSetup(el ? el.Setup : null),
      Output: this.initOutput(el ? el.Output : null),
      AcceptanceRate: [el ? el.AcceptanceRate : '', [Validators.max(99999), Validators.min(0)]],
      Comment: [el ? el.Comment : '']
    });
  }

  initJobData(el?: any) {
    return this.fb.group({
      Name: el ? el.Name : '',
      Machine: el ? el.Machine : '',
      Serial: el ? el.Serial : '',
      Material: el ? el.Material : ''
    });
  }

  initSetup(el?: any) {
    return this.fb.group({
      CurrentPerformance: [el ? el.CurrentPerformance : '', [Validators.max(99999), Validators.min(0)]],
      EstimatedPerformance: [el ? el.EstimatedPerformance : '', [Validators.max(99999), Validators.min(0)]],
      MeasuredPerformance: [el ? el.MeasuredPerformance : '', [Validators.max(99999), Validators.min(0)]]
    });
  }

  initOutput(el?: any) {
    return this.fb.group({
      CurrentPerformance: [el ? el.CurrentPerformance : '', [Validators.max(99999), Validators.min(0)]],
      EstimatedPerformance: [el ? el.EstimatedPerformance : '', [Validators.max(99999), Validators.min(0)]],
      MeasuredPerformance: [el ? el.MeasuredPerformance : '', [Validators.max(99999), Validators.min(0)]]
    });
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['jobAnalysisItems'];
    control.removeAt(this.jobToRemove);
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['jobAnalysisItems'];
    control.push(this.initJobAnalysisItem());
  }

  initForm() {
    this.editForm = this.fb.group({
      jobAnalysisItems: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['jobAnalysisItems'];
    if (this.jobAnalysisItems && this.jobAnalysisItems.length) {
      _.forEach(this.jobAnalysisItems, (el) => {
        control.push(this.initJobAnalysisItem(el));
      });
    } else {
      control.push(this.initJobAnalysisItem());
    }
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['jobAnalysisItems'];
  }

  save(model: any) {
    this.processing = true;
    this.service.updateJobAnalysis(this.inspectionId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openJobAnalysisItemDeleteConfirm(i: number) {
    this.jobDeleteConfirm.open();
    this.jobToRemove = i;
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public openModelsSelector(i: number): void {
    const control = <UntypedFormArray>this.editForm.controls['jobAnalysisItems'];
    this.modelCurrentItem = control.controls[i];
    let machineValue = this.modelCurrentItem.controls['JobData'].controls['Machine'].value;
    let serialValue = this.modelCurrentItem.controls['JobData'].controls['Serial'].value;
    const modelIndex = _.findIndex(
      this.modelsValues,
      (el) => el.name === machineValue && el.CustomerEquipementId === serialValue
    );
    this.openSelector(this.modelsModal, this.modelsValues, modelIndex);
  }

  public selectModelsMenu(item: any) {
    this.modelCurrentItem.controls['JobData'].controls['Machine'].setValue(item.value.name);
    this.modelCurrentItem.controls['JobData'].controls['Serial'].setValue(item.value.CustomerEquipementId);
    this.modelCurrentItem.controls['JobData'].controls['Machine'].markAsTouched();
  }

  public onClose() {
    this.modelCurrentItem.controls['JobData'].controls['Machine'].markAsTouched();
  }

  public getAcceptanceRate(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['jobAnalysisItems'];
    let job = control.controls[i].value;
    return this.service.getAcceptanceRate(job);
  }
}
